/**
 * Krok SEZ1 bod 2 — ODESLANI ZAPISU. Jedno volani na jedno kliknuti; do ceho
 * se zapisuje a proc je v ROZHODNUTI SEZ1-ZAPIS (`record-activity.ts`).
 */

import { addCaseNote } from './cases-api.js';
import { createTask } from './tasks-api.js';
import type { ActivityRecord } from './record-activity.js';

/** Komu zapis patri. Prave jedna z moznosti — klient, nebo zakazka. */
export type ActivityTarget =
  | { readonly kind: 'party'; readonly partyId: string }
  | { readonly kind: 'case'; readonly caseId: string };

export async function recordActivity(target: ActivityTarget, record: ActivityRecord): Promise<void> {
  /*
   * Zakazka: co se STALO jde do historie zakazky (jedina vec, kterou
   * „Poslední dění" umi precist); co se MA STAT je ukol s terminem, aby to
   * vyskocilo na Dnesku.
   */
  if (target.kind === 'case') {
    if (record.status === 'done') {
      await addCaseNote(target.caseId, record.historyText);
      return;
    }
    await createTask({
      title: record.title,
      status: 'todo',
      caseId: target.caseId,
      ...(record.description !== null ? { description: record.description } : {}),
      ...(record.dueAt !== null ? { dueAt: record.dueAt } : {}),
    });
    return;
  }

  /*
   * Klient: strana zadnou vlastni historii nema. Dokonceny ukol je presne
   * to, z ceho seznam klientu pocita „posledni kontakt" (`client-activity.ts`).
   */
  await createTask({
    title: record.title,
    status: record.status,
    partyId: target.partyId,
    ...(record.description !== null ? { description: record.description } : {}),
    ...(record.dueAt !== null ? { dueAt: record.dueAt } : {}),
  });
}
